import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { register } from '../auth/authActions';
import './Register.css';
import { useNavigate, Link } from 'react-router-dom'; // Import Link from react-router-dom
import { useTranslation } from 'react-i18next';
import { loginSuccess } from '../auth/authSlice';

const Register = () => {
    const { t } = useTranslation();

    const [newUsername, setNewUsername] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newEmail, setNewEmail] = useState('');
    const [acceptedTerms, setAcceptedTerms] = useState(false); // New state variable for accepting Terms and Conditions
    const [showErrorOverlay, setShowErrorOverlay] = useState(false);
    const [showSuccessOverlay, setShowSuccessOverlay] = useState(false);
    const [token, setToken] = useState('');
    const [usernameError, setUsernameError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [errStatus, setErrorStatus] = useState();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn); // Move useSelector here


    useEffect(() => {
        if(isLoggedIn)
        {
            navigate("/mygames");
        }
    }, [isLoggedIn, navigate]); 

    const handleRegister = async () => {
                // Clear previous errors
                setUsernameError('');
                setPasswordError('');
                setEmailError('');
                setShowErrorOverlay(false);
        
        console.log("handleRegister");
        if (!acceptedTerms) {
            alert(t("accept_terms_alert")); // Alert the user if they haven't accepted the Terms and Conditions
            return;
        }

        const usernameTrimmed = newUsername.trim();
        const passwordTrimmed = newPassword.trim();
        const emailTrimmed = newEmail.trim();

        let hasClientSideError = false;

        if (usernameTrimmed.length <= 6) {
            setUsernameError(t('username_length_error'));
            hasClientSideError = true;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email format validation
        if (!emailRegex.test(emailTrimmed)) {
            setEmailError(t('email_format_error'));
            hasClientSideError = true;
        }

        const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d).{7,}$/; // At least 1 letter, 1 number, min 7 symbols
        if (!passwordRegex.test(passwordTrimmed)) {
            setPasswordError(t('password_complexity_error'));
            hasClientSideError = true;
        }

        if (hasClientSideError) {
            setShowErrorOverlay(true);
            return;
        }

        const result = await dispatch(register(usernameTrimmed, passwordTrimmed, emailTrimmed));

        if (result === 409)
            {
                setErrorStatus(result);
                setShowErrorOverlay(true);
                
            } 
        else if(!result)
        {
            setShowErrorOverlay(true);
        }
        else {
            setShowSuccessOverlay(true);
            setToken(result.token);
        }
    };

    const handleCloseSuccessOverlay = () => {
        setShowSuccessOverlay(false);

        
        //navigate('/login');

        //Change Login state in the app
        dispatch(loginSuccess());

        // Save token from the result to localStorage
        localStorage.setItem('token', token);

        //Open the container for my games
        navigate("/mygames")
    };

    return (
        <div className="login-container">
            <form className="login-form">
                <h2>{t("register")}</h2>
                <label>
                {t("username")}:
                       <input type="text" value={newUsername} onChange={(e) => setNewUsername(e.target.value)} className={usernameError ? 'input-error' : ''} />
                    {usernameError && <p className="error-message-inline">{usernameError}</p>}
                 </label>
                <label>
                {t("password")}:
                <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className={passwordError ? 'input-error' : ''} />
                    {passwordError && <p className="error-message-inline">{passwordError}</p>}
                 </label>
                <label>
                {t("email")}:
                <input type="email" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} className={emailError ? 'input-error' : ''} />
                {emailError && <p className="error-message-inline">{emailError}</p>} 
                </label>
                {/* Checkbox for accepting Terms and Conditions */}
                <label>
                    <input type="checkbox" checked={acceptedTerms} onChange={() => setAcceptedTerms(!acceptedTerms)} />
                    {t("i_accept")} <Link to="/terms-and-conditions">{t("terms_and_conditions1")}</Link>
                </label>
                <button type="button" onClick={handleRegister}>
                {t("register")}
                </button>
            </form>

            {/* Overlay error */}
            {showErrorOverlay && (
                <div className="overlay">
                         <div className="overlay-content error-overlay-content">
                        <h2>{t("registration_error")}</h2>
                        {usernameError && <p>{usernameError}</p>}
                        {passwordError && <p>{passwordError}</p>}
                        {emailError && <p>{emailError}</p>} 
                         {errStatus === 409 && (<p>{t("username_email_exist")}</p>)}
                        <p>{t("error_during_registration")}</p>
                        <button onClick={() => setShowErrorOverlay(false)}>{t("close")}</button>
                    </div>
                </div>
            )}

            {/* Overlay success */}
            {showSuccessOverlay && (
                <div className="overlay">
                    <div className="overlay-content">
                        <h2>{t("successful_registration")}</h2>
                        <p>{t("successful_registration2")}</p>
                        <button onClick={handleCloseSuccessOverlay}>{t("close")}</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Register;
